var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71289 1.6084H19.0664M5.71289 6.80141H19.0664M5.71289 11.9944H19.0664",
    stroke: "#706F6F",
    strokeWidth: 2.22558,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00358 2.35017C2.4133 2.35017 2.74544 2.01803 2.74544 1.60831C2.74544 1.1986 2.4133 0.866455 2.00358 0.866455C1.59386 0.866455 1.26172 1.1986 1.26172 1.60831C1.26172 2.01803 1.59386 2.35017 2.00358 2.35017Z",
    stroke: "#706F6F",
    strokeWidth: 1.48372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00358 7.54329C2.4133 7.54329 2.74544 7.21115 2.74544 6.80143C2.74544 6.39171 2.4133 6.05957 2.00358 6.05957C1.59386 6.05957 1.26172 6.39171 1.26172 6.80143C1.26172 7.21115 1.59386 7.54329 2.00358 7.54329Z",
    stroke: "#706F6F",
    strokeWidth: 1.48372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00358 12.7362C2.4133 12.7362 2.74544 12.404 2.74544 11.9943C2.74544 11.5846 2.4133 11.2524 2.00358 11.2524C1.59386 11.2524 1.26172 11.5846 1.26172 11.9943C1.26172 12.404 1.59386 12.7362 2.00358 12.7362Z",
    stroke: "#706F6F",
    strokeWidth: 1.48372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/media/icon-list.1ba26b3100922899b448f6b9d484eed5.svg";
export { ForwardRef as ReactComponent };